import { OTHER_DISPLAY } from "@/components/ClearableYesNoRadioField/utils/yes-no-other-questionnaire-answer";
import { NO_DISPLAY, YES_DISPLAY } from "@/intake-forms/constants/yes-no-display";

export const yesNoRadioOptions = [
  { label: YES_DISPLAY, value: YES_DISPLAY },
  { label: NO_DISPLAY, value: NO_DISPLAY },
] as const;

/** Yes/No/Other options for ClearableYesNoRadioField via the `options` prop. */
export const yesNoOtherRadioOptions = [
  { label: YES_DISPLAY, value: YES_DISPLAY },
  { label: NO_DISPLAY, value: NO_DISPLAY },
  { label: OTHER_DISPLAY, value: OTHER_DISPLAY },
] as const;

export type YesNoRadioOption = (typeof yesNoRadioOptions)[number];
export type YesNoOtherRadioOption = (typeof yesNoOtherRadioOptions)[number];

export type ClearableRadioOption = {
  label: string;
  value: string;
};
